import './utils/setupLogging';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { configure } from 'mobx'
import App from './App'
import { UnifiedStoreProvider } from './stores/UnifiedStoreProvider'
import { StytchProvider } from './components/auth/StytchProvider'
import ErrorBoundary from './components/ErrorBoundary'
import { setupApiInterceptors } from './services/ApiInterceptor'
import { initializeAppStorage } from './utils/localStorage'
// Removed InstantDBProvider - using WebSocket only

// Clear legacy hardcoded data on app start
initializeAppStorage();

// Setup API interceptors for logging and toasts
setupApiInterceptors();

// Configure MobX
configure({
  enforceActions: 'always',
})

// Import AG Grid styles first
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

// Import AG Grid modules
import { ModuleRegistry, ClientSideRowModelModule } from 'ag-grid-community'

// Register required modules
ModuleRegistry.registerModules([
  ClientSideRowModelModule
])

// Define browser tools functions for testing and debugging
const initializeBrowserTools = () => {
  console.log('Browser Tools Initialization (Attempt 1)');
  
  try {
    // Set a flag that browser tools are available
    (window as any).browserToolsAvailable = true;
    console.log('Browser tools flag set');
    
    // Set up global error handler to log errors
    window.addEventListener('error', (event) => {
      console.error('Global error:', event.error);
      console.error('Error details:', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        stack: event.error?.stack
      });
      // Check if this error might cause a reload
      if (event.error?.message?.includes('Failed to fetch')) {
        console.warn('⚠️ Failed to fetch error detected - this might indicate a page reload!');
      }
    });
    console.log('Global error handler set');
    
    // Set up unhandled promise rejection handler
    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      if (event.reason?.message?.includes('Failed to fetch')) {
        console.warn('⚠️ Failed to fetch in promise rejection - possible page reload!');
      }
    });
    console.log('Unhandled promise rejection handler set');
    
  } catch (error) {
    console.error('Failed to initialize browser tools:', error);
    
    // Try again after a delay
    setTimeout(() => {
      console.log('Browser Tools Initialization (Retry)');
      try {
        (window as any).browserToolsAvailable = true;
      } catch (retryError) {
        console.error('Failed to initialize browser tools on retry:', retryError);
      }
    }, 2000);
  }
};

// Create app root and render
const rootElement = document.getElementById('root');
if (rootElement) {
  // Prevent multiple createRoot calls during HMR
  const w = window as any;
  if (!w.__APP_ROOT__) {
    console.log('[main.tsx] Creating React root...');
    w.__APP_ROOT__ = ReactDOM.createRoot(rootElement);
  } else {
    console.log('[main.tsx] Reusing existing React root');
  }

  w.__APP_ROOT__.render(
    // Temporarily disabled StrictMode to prevent MST/WebSocket loops in dev
    // <React.StrictMode>
      <ErrorBoundary>
        <StytchProvider>
          {/* AuthGate wraps UnifiedStoreProvider to prevent store creation before auth */}
          <UnifiedStoreProvider>
            <App />
          </UnifiedStoreProvider>
        </StytchProvider>
      </ErrorBoundary>
    // </React.StrictMode>
  );
}

// Start initialization with delay
setTimeout(() => {
  initializeBrowserTools();
}, 1000);

// Log that initialization is complete
console.log('Browser tools initialized');
console.log('AG Grid setup complete');

// Enable Hot Module Replacement (HMR)
// This means we can edit our components and see changes without refreshing the page
// The state of the app is preserved between changes
if (import.meta.hot) {
  import.meta.hot.accept();
}
